module.exports = __webpack_public_path__ + "images/maskable_icon-512.ce6a099d841e7f1b6a99fed355b68b1d.png";